import React from "react";
import ReactDOM from "react-dom/client";
// import './index.css';
import "./styles/main.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Dev-only: expose Firebase SDK on window.sahod for PRD §13.9 console tests.
// REACT_APP_ENVIRONMENT=production builds skip this; UAT installs it.
if (process.env.REACT_APP_ENVIRONMENT !== "production") {
  // eslint-disable-next-line global-require
  require("./utils/devConsole").installDevConsole();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
